import AsyncStorage from '@react-native-async-storage/async-storage';
import { API } from '../../utils';

export const getUserProfile = async () => {
  try {
    const user_id = await AsyncStorage.getItem('id');
    const session_key = await AsyncStorage.getItem('key'); // token/session_key

    if (!user_id) throw new Error('User ID not found in AsyncStorage');

    const myHeaders = new Headers();
    myHeaders.append("id", user_id);
    myHeaders.append("session_key", session_key);
    myHeaders.append("Authorization", "Basic YWRtaW46MTIzNA==");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    const response = await fetch(`${API.baseurl}${API.getprofile}`, requestOptions);

    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const data = await response.json();

    return data;
  } catch (error) {
    console.error('Error in getUserProfile:', error);
    throw error;
  }
};


export const AddFcmToken = async () => {
  try {
    const user_id = await AsyncStorage.getItem('id');
    const session_key = await AsyncStorage.getItem('key'); 
    const DeviceToken = await AsyncStorage.getItem('DeviceToken'); 

    if (!user_id || !DeviceToken) {
      console.log("User ID or DeviceToken is missing");
      return;
    }

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', // agar aap CI ke $_POST use kar rahe ho
        'Authorization': `Bearer ${session_key || ''}` // optional, agar aapke API me auth chahiye
      },
      body: `user_id=${encodeURIComponent(user_id)}&fcmToken=${encodeURIComponent(DeviceToken)}`
    };

    const response = await fetch(`${API.baseurl}${API.addToken}`, requestOptions);
    const data = await response.json();

    if (data.status) {
      console.log("FCM Token updated successfully:", data.message);
    } else {
      console.log("Failed to update FCM Token:", data.message);
    }
    return data

  } catch (error) {
    console.log("Error in AddFcmToken:", error.message);
    return error
  }
};